import React, { useEffect } from "react";
import { object, string } from "prop-types";
import { connect } from "react-redux";
import get from "lodash/get";

import { formatDate, getStoryDate } from "../../helper/date-utils";
import { setTimeOnClient } from "../../utils/utils";

import "./first-published.m.css";

const FirstPublished = ({ story, publisherName }) => {
  useEffect(() => {
    // As we're adding 5h30m on SSR so, on FE below snippet will cut off that 5h30m to make it consistent accross!
    // setTimeOnClient();
  }, []);

  const isRepublished = story["published-at"] !== story["first-published-at"];
  // const firstPublishedTime = formatDate(story["first-published-at"]);
  const firstPublishedTime = getStoryDate(story["first-published-at"])
  const isLiveBlog = get(story, ["story-template"], "") === "live-blog";

  return isRepublished ? (
    <div styleName="published-wrapper">
      <span styleName="title">Published:&nbsp;</span>
      {!isLiveBlog ? (
        <time
          dateTime={`${new Date(story["first-published-at"]).toISOString().replace("Z", "+00:00")}`}
          styleName="date"
        >
          {firstPublishedTime}
        </time>
      ) : (
        <span
          data-time={`${new Date(story["first-published-at"]).toISOString().replace("Z", "+00:00")}`}
          styleName="date"
          className="published_only"
        >
          {firstPublishedTime}
        </span>
      )}
    </div>
  ) : null;
};

FirstPublished.propTypes = {
  story: object,
  publisherName: string,
};

const mapStateToProps = (state) => ({
  publisherName: get(state, ["qt", "config", "publisher-attributes", "name"], null),
});

export default connect(mapStateToProps, null)(FirstPublished);
